import { AppConfig } from './app-config.model';

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json');

  if (!res.ok) throw new Error('Config load failed');

  return res.json();
}